module.exports = __webpack_public_path__ + "static/media/background_.a9316d3c.png";